<template>
  <HPopup class="h-level-rank"
          ref="popup"
          v-show="visible">
    <p class="popup-header">盗贼之家</p>
    <p class="intro ls-1 fs-12 white center">在树丛下你找到通往盗贼之家的秘密通道，一个老“熟人”向你提供了他所掌握的最新情报。</p>
    <div class="rank-list" v-if="rankList.length">
      <div class="rank-item h-bg brown-2 h-outer-border around-4 bw2 bz0"
           v-for="(item, index) in rankList">
        <div class="rank" :class="[ index >= 10 ? 'light' : '' ]">
          <template v-if="index < 3">
            <img :src="`${$rHost}/img/common/rank/rank_${index +  1}.png`" alt="">
          </template>
          <template v-else>
            {{ index + 1 }}
          </template>
        </div>
        <div class="awatar-wrapper">
          <div class="avatar h-outer-border around-4 bw2 bz0">
            <template v-if="index < 3">
              <img class="effect" :src="`${$rHost}/img/common/effect/rect_gold_200_1.webp`" alt="">
            </template>
            <div class="icon-avatar-wrapper">
              <img class="icon-avatar" :src="item.avatar" alt="">
            </div>
          </div>
        </div>
        <div class="nick">{{ item.nick }}</div>
        <div class="level">等级 {{item.level}}</div>
      </div>
    </div>
    <div v-else class="empty h-bg brown-2 h-outer-border around-4 bw2 bz0">
      暂无排行
    </div>

    <div class="footer center">
      <button ref="button"
              v-click-sound-button
              class="h-btn ok btn-border"
              @click="handleClose">
      </button>
    </div>
  </HPopup>
</template>

<script>
  import HPopup from '@/components/h-popup/index.vue'
  import API from '@js/api'
  import AudioCtrl from '@js/audio-ctrl'
  import AUDIO from '@/js/constants/AUDIO'

  export default {
    name: 'h-level-rank',

    beforeDestroy () {
      if (this.audioId) {
        AudioCtrl.stop(this.audioId)
      }
    },

    data () {
      return {
        rankList: [],
        audioId: null,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    async mounted () {
      this.getRankList()
      this.audioId = AudioCtrl.play({ url: AUDIO.SCENE.DenOfThieves, loop: false })
    },

    methods: {
      async getRankList () {
        try {
          this.rankList = await API.hero.getHeroLevelRank()
        } catch (err) {
          console.error(err)
          this.$message(err)
        }
      },

      handleClose () {
        this.$emit('close')
      },
    },

    components: {
      HPopup,
    }
  }
</script>


<style lang="stylus" scoped>
  .h-level-rank /deep/ .h-popup-container
    width 642px !important

  .empty
    whiteText1()
    padding 10px 0
    line-height 20px
    font-size 12px
    text-align center
    letter-spacing 2px

  .rank-list
    margin-top 20px
    display flex
    flex-direction column
    flex-wrap wrap
    align-items center
    max-height 380px

  .rank-item
    width 302px
    display flex
    align-items center
    font-size 12px
    padding 3px 2px
    margin 0 2px 2px 2px
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3)
      .rank
        font-size 14px
        font-weight bold
        color $colorYellow
    &:nth-child(1) .rank img
      filter drop-shadow(0 0 3px #d32f2d)
    &:nth-child(2) .rank img
      filter drop-shadow(0 0 3px #aeb7b3)
    &:nth-child(3) .rank img
      filter drop-shadow(0 0 3px #b95f10)
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3)
      .effect
        z-index 1
        position absolute
        top -21px
        left -13px
        width 58px
        height 63px
    &:nth-child(1) .effect
        filter hue-rotate(330deg)
    &:nth-child(2) .effect
        filter hue-rotate(210deg)
    &:nth-child(3) .effect
        filter hue-rotate(15deg) grayscale(0.2)
    &:hover
      box-shadow 1px 1px 1px #000
    .rank
      display flex
      align-items center
      justify-content center
      color $colorGold
      text-shadow 0 2px 2px #000
      width 40px
      height 30px
      padding 0 1px
      line-height 30px
      text-align center
      font-size 14px
      img
        max-width 100%
      &.light
        font-size 12px
        opacity 0.75
    .awatar-wrapper
      position relative
      width 30px
      height 30px
      border-radius 2px
      border 1px solid transparent
    .avatar
      position relative
      z-index 1
      width 28px
      height 28px
      padding 2px
      border-radius 2px
      .icon-avatar-wrapper
        position absolute
        top 2px
        left 2px
        z-index 0
        overflow hidden
        display flex
        justify-content center
        align-items center
        width 24px
        height 24px
        .icon-avatar
          max-width 100%
    .nick
      width 158px
      whiteText1()
      padding-left 5px
      letter-spacing 2px
      color #ddd
    .level
      width 70px
      padding-right 2px
      flex-grow 1
      text-align right
      whiteText1()
      color #aaa

  .footer
    margin-top 30px
</style>
